import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { pure } from '../../../node_module_clones/recompose';

// Utils
import { isPlatformIframe } from '../../platform/utils/platformDetailsUtils';

// Selectors
import { getPlatformDetailsSelector } from '../../platform/platformSelector';
import { isSocketDisconnected } from '../../utils/socket/socketConnectionSelector';
import { appDisableSocketStatusWarningsSelector } from '../../offline/appServerConnection/appServerReconnectionSelector';

// Components
import LogoSpinner from '../loaders/LogoSpinner';

// Styles
import './SocketConnectionStatusError.scss';

// The time to wait until the socket is initialised, before showing the reconnecting spinner
// This might happen when logging in from a published board
// FIXME - Remove this state - it should instead use the disableSocketStatusWarnings state from the store
const AWAIT_FOR_INITIALISATION_TIMEOUT = 10000;

const mapStateToProps = createStructuredSelector({
    disableSocketStatusWarnings: appDisableSocketStatusWarningsSelector,
    platformDetails: getPlatformDetailsSelector,
});

const SocketConnectionStatusError = (props) => {
    const { isGuest, socketConnection, socketConnectionIsInitialised, disableSocketStatusWarnings, platformDetails } =
        props;

    // FIXME - Remove this state - it should instead use the disableSocketStatusWarnings state from the store
    const [awaitSocketInitialisation, setAwaitSocketInitialisation] = React.useState(true);

    React.useEffect(() => {
        // FIXME - Remove this state - it should instead use the disableSocketStatusWarnings state from the store
        if (!isGuest && !socketConnectionIsInitialised && !isPlatformIframe(platformDetails)) {
            setTimeout(() => {
                setAwaitSocketInitialisation(false);
            }, AWAIT_FOR_INITIALISATION_TIMEOUT);
        }
    }, [isGuest]);

    const hideErrorMessage =
        isGuest ||
        !isSocketDisconnected(socketConnection) ||
        disableSocketStatusWarnings ||
        (!socketConnectionIsInitialised && awaitSocketInitialisation);

    if (hideErrorMessage) return null;

    return (
        <div className="SocketConnectionStatusError">
            <LogoSpinner />
        </div>
    );
};

SocketConnectionStatusError.propTypes = {
    socketConnectionIsInitialised: PropTypes.bool,
    socketConnection: PropTypes.object,
    isGuest: PropTypes.bool,
    disableSocketStatusWarnings: PropTypes.bool,
    platformDetails: PropTypes.object,
};

export default pure(connect(mapStateToProps)(SocketConnectionStatusError));
